/**
 * インストーラーダウンロードページ
 *
 * クライアント向けインストーラーのダウンロード管理
 */

import { Title, Stack } from "@mantine/core";
import { InstallerDownloadPanel } from "../components/delivery/InstallerDownloadPanel";

export function InstallerPage() {
  return (
    <Stack gap="lg">
      <Title order={1}>クライアントインストーラー</Title>
      <InstallerDownloadPanel />
    </Stack>
  );
}
